<div class="p-grid">
	<div class="p-col-12 p-md-6">
		<p-fieldset legend="In-Store Setup">
			<div class="d-flex flex-column">
				<div>
					<span class="p-float-label mt-4">
						<input
							pInputText
							#focusPayStoreLevelDeploymentIdInput
							name="focusPayStoreLevelDeploymentIdInput"
							type="text"
							[(ngModel)]="venueService.subscriptionVenue.value.ccProcessorApiKey"
							class="w-100"
							(change)="onChange()"
						/>
						<label for="focusPayStoreLevelDeploymentIdInput">Store-level deployment ID</label>
					</span>
				</div>
				<!-- <div>
					<span class="p-float-label mt-4">
						<input
							pInputText
							#focusPayStoreLevelReportingApiKey
							name="focusPayStoreLevelReportingApiKey"
							type="text"
							[(ngModel)]="venueService.subscriptionVenue.value.ccProcessorApiSecret"
							class="w-100"
							(change)="onChange()"
						/>
						<label for="focusPayStoreLevelReportingApiKey">Reporting ID Key</label>
					</span>
				</div> -->
				<span class="p-float-label mt-4">
					<p-dropdown
						#storeLevelPaymentProcessor
						[options]="ccProcessors"
						optionLabel="label"
						optionValue="value"
						name="storeLevelPaymentProcessor"
						[(ngModel)]="venueService.subscriptionVenue.value.ccProcessor"
						[disabled]="userService.userSubscription.value.role < 5"
						[style]="{ width: '100%' }"
						appendTo="body"
						[autoDisplayFirst]="false"
						[virtualScroll]="true"
						itemSize="30"
						filter="true"
						(filterBy)="app.keys(ccProcessors)"
						(onChange)="saveVenue()"
					></p-dropdown>
					<label for="storeLevelPaymentProcessor">Store-Level Payment Engine</label>
				</span>
			</div>
		</p-fieldset>
	</div>
	<div class="p-col-12 p-md-6">
		<p-fieldset legend="Online Setup">
			<ng-container *ngIf="venueService.ooVenue">
				<div class="d-flex flex-column">
					<div>
						<span class="p-float-label mt-4">
							<input
								pInputText
								#focusPayECommerceDeploymentIdInput
								name="focusPayECommerceDeploymentIdInput"
								type="text"
								[(ngModel)]="venueService.ooVenue.ccProcessorApiKey"
								class="w-100"
								(change)="onChange()"
							/>
							<label for="focusPayECommerceDeploymentIdInput">eComm Deployment ID</label>
						</span>
					</div>
					<div>
						<span class="p-float-label mt-4">
							<input
								pInputText
								#focusPayECommerceTokenIdInput
								name="focusPayECommerceTokenIdInput"
								type="text"
								[(ngModel)]="venueService.ooVenue.ccProcessorApiSecret"
								class="w-100"
								(change)="onChange()"
							/>
							<label for="focusPayECommerceTokenIdInput">eComm Token Key</label>
						</span>
					</div>
				</div>
				<span class="p-float-label mt-4">
					<p-dropdown
						#eCommercePaymentProcessor
						[options]="ccProcessors"
						optionLabel="label"
						optionValue="value"
						name="eCommercePaymentProcessor"
						[(ngModel)]="venueService.ooVenue.ccProcessor"
						[disabled]="userService.userSubscription.value.role < 5"
						[style]="{ width: '100%' }"
						appendTo="body"
						[autoDisplayFirst]="false"
						[virtualScroll]="true"
						itemSize="30"
						filter="true"
						(filterBy)="app.keys(ccProcessors)"
					></p-dropdown>
					<label for="eCommercePaymentProcessor">eCommerce Payment Engine</label>
				</span>
			</ng-container>
		</p-fieldset>
	</div>
</div>
